var map = {
	"./AritcleAdminComponents": 17,
	"./AritcleAdminComponents.jsx": 17,
	"./AritcleComponents": 11,
	"./AritcleComponents.jsx": 11,
	"./Article": 77,
	"./Article.jsx": 77,
	"./BigPlayer": 78,
	"./BigPlayer.jsx": 78,
	"./Editor": 81,
	"./Editor.jsx": 81,
	"./PZTMap": 82,
	"./PZTMap.jsx": 82,
	"./Player": 84,
	"./Player.jsx": 84,
	"./Puzzle": 85,
	"./Puzzle.jsx": 85,
	"./Tinymce": 86,
	"./Tinymce.jsx": 86,
	"./WasteManagementMap": 87,
	"./WasteManagementMap.jsx": 87,
	"./audio-big-player": 36,
	"./audio-big-player.scss": 36,
	"./audio-player": 38,
	"./audio-player.scss": 38,
	"./editor": 37,
	"./editor.sass": 37,
	"./loading": 88,
	"./loading.gif": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;